/**
 * Format minutes into human-readable duration string.
 * Examples: 6 → "6m", 90 → "1h 30m", 120 → "2h", 1500 → "1d 1h", 2880 → "2d"
 */
export const formatTimeSaved = (mins: number): string => {
  if (mins <= 0) return "—";
  if (mins < 60) return `${mins}m`;
  const totalHours = Math.floor(mins / 60);
  const m = mins % 60;
  if (totalHours < 24) return m > 0 ? `${totalHours}h ${m}m` : `${totalHours}h`;
  const d = Math.floor(totalHours / 24);
  const h = totalHours % 24;
  if (h === 0 && m === 0) return `${d}d`;
  if (h === 0) return `${d}d ${m}m`;
  if (m === 0) return `${d}d ${h}h`;
  return `${d}d ${h}h ${m}m`;
};

/**
 * Returns a human-friendly work-context equivalent only when >= 24h.
 * Under 24h returns null — hours format is already self-explanatory.
 * workingMinutesPerDay defaults to 480 (8h) if not provided.
 * Examples: 1440 → "≈ 3 work days", 2400 → "≈ 1 work week"
 */
export const formatTimeSavedHuman = (mins: number, workingMinutesPerDay = 480): string | null => {
  if (mins < 24 * 60) return null;
  const WORK_WEEK = 5 * workingMinutesPerDay;
  if (mins < WORK_WEEK) {
    const days = (mins / workingMinutesPerDay).toFixed(1).replace(/\.0$/, "");
    return `≈ ${days} work ${parseFloat(days) === 1 ? "day" : "days"}`;
  }
  const weeks = (mins / WORK_WEEK).toFixed(1).replace(/\.0$/, "");
  return `≈ ${weeks} work ${parseFloat(weeks) === 1 ? "week" : "weeks"}`;
};
